import { TopMenu } from 'components/common/Menu';
import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import menuConfig from './menuConfig';
import { H2 } from '@montel/montelpro-shared-components-v2';
import Page from 'components/common/Page';

const AccountsOutlet: FunctionComponent = () => (
	<Page>
		<H2 as={'h1'}>Montel accounts</H2>
		<TopMenu menuConfig={menuConfig} />
		<Outlet />
	</Page>
);

export default AccountsOutlet;
